import { render } from "./ScColorPickerModal.vue?vue&type=template&id=1e504c58"
import script from "./ScColorPickerModal.vue?vue&type=script&lang=js"
export * from "./ScColorPickerModal.vue?vue&type=script&lang=js"

import "./ScColorPickerModal.vue?vue&type=style&index=0&id=1e504c58&lang=css"

import exportComponent from "/home/runner/work/webapp/webapp/main/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__